export const SERVICE_TYPES = [
  "Breakdown & Emergency Recovery",
  "BMW Factory Diagnostic Search",
  "BMW Navigation Map Conversion",
  "Scheduled Servicing",
  "Brake & Suspension Repair",
  "Engine & Performance",
  "Pre-WOF check / inspection",
  "Other",
];

export const BREAKDOWN_TYPE = SERVICE_TYPES[0];
export const BMW_TYPE = SERVICE_TYPES[1];
export const NAV_TYPE = SERVICE_TYPES[2];

export const PHONE_DISPLAY = "+64 22 566 5221";
export const PHONE_TEL = "tel:+64225665221";
export const PHONE2_DISPLAY = "027 362 6970";
export const PHONE2_TEL = "tel:+64273626970";
export const PHONES = [
  { display: PHONE_DISPLAY, tel: PHONE_TEL, id: "primary" },
  { display: PHONE2_DISPLAY, tel: PHONE2_TEL, id: "secondary" },
];
export const WHATSAPP_URL = "https://wa.me/64225665221";
export const HOURS = "Open 7 days, 8:00am–5:30pm";
export const ADDRESS = "Unit 1, 9 Cherokee Place, Mount Maunganui 3116";
export const MAP_EMBED_URL =
  "https://www.google.com/maps?q=Unit+1,+9+Cherokee+Place,+Mount+Maunganui+3116,+New+Zealand&output=embed";

export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim());
export const isValidPhone = (v) => {
  const digits = String(v).replace(/\D/g, "");
  return /^[+\d\s()-]+$/.test(String(v).trim()) && digits.length >= 7 && digits.length <= 15;
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1714434087684-a2f4816ca832?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  bmw: "https://images.unsplash.com/photo-1769641240978-fff8b96d3b42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  nav: "https://images.unsplash.com/photo-1622642468182-edd7db43f86e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  engine: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=1200&auto=format&fit=crop",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
